import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-viewList",
  "use": "icon-viewList-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icon-viewList\">\n  <path d=\"M21 6.75H3V5.25H21V6.75Z\" fill=\"black\" />\n  <path d=\"M21 12.75H3V11.25H21V12.75Z\" fill=\"black\" />\n  <path d=\"M3 18.75V17.25H21V18.75H3Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol